import React, { useState } from "react";
import QuoteSubmission from "./QuoteSubmission";
import VisualDisplay from "./VisualDisplay";
import "./Estimator.css";
import "./FeaturesReview.css";

interface FeaturesReviewPageProps {
    jsonResponse: any;
    backToUpload: () => void;
    accessToken: string | null;
}

const FeaturesReviewPage: React.FC<FeaturesReviewPageProps> = ({ jsonResponse, backToUpload, accessToken }) => {
    const [isQuoteSubmitted, setIsQuoteSubmitted] = useState(false);

    const handleGoBackFromQuote = () => {
        setIsQuoteSubmitted(false); // Reset the submission state
    };

    const [isFormValid, setIsFormValid] = useState(false);

    return (
        // Show retrieved data
        <div className="response-container">
            <div className="table-and-visual">
                {/* Don't want the visualizer to show when the user creates a list from scratch.
                    We also don't want this instance of the visualizer to stay on the screen
                    when the user goes to the estimated price page. */}
                <div className={`table-data ${isQuoteSubmitted || !jsonResponse["_touchingEntitiesList"]?.length
                    ? "no-border"
                    : ""
                    }`}>
                    <QuoteSubmission
                        featureGroups={jsonResponse["_featureGroups"]}
                        touchingEntities={jsonResponse["_touchingEntitiesList"]}
                        minX={jsonResponse["minX"]}
                        minY={jsonResponse["minY"]}
                        maxX={jsonResponse["maxX"]}
                        maxY={jsonResponse["maxY"]}
                        accessToken={accessToken}
                        backToUpload={backToUpload}
                        onQuoteSubmit={() => setIsQuoteSubmitted(true)}
                        onQuoteGoBack={handleGoBackFromQuote}
                        setIsFormValid={setIsFormValid}
                    />
                    {!isQuoteSubmitted && (
                        <div className="button-container">
                            <button className="animated-button" onClick={backToUpload}>
                                <span>Go Back</span>
                                <span></span>
                            </button>
                            <div className="confirm-button-wrapper" data-tooltip={!isFormValid ? "Please fill out all required fields in red." : undefined}>
                            <button
                                form="quote-form"
                                type="submit"
                                className={`animated-button submit-button ${!isFormValid ? "disabled-button" : ""}`}
                                disabled={!isFormValid}
                            >
                                <span>Confirm</span>
                                <span></span>
                                </button>
                            </div>
                        </div>
                    )}
                </div>
                {!isQuoteSubmitted && jsonResponse["_touchingEntitiesList"]?.length > 0 && (
                    <div className="visual">
                        <VisualDisplay
                            touchingEntities={jsonResponse["_touchingEntitiesList"]}
                            minX={jsonResponse["minX"]}
                            minY={jsonResponse["minY"]}
                            maxX={jsonResponse["maxX"]}
                            maxY={jsonResponse["maxY"]}
                        />
                    </div>
                )}
                
            </div>
        </div>
    );
};

export default FeaturesReviewPage;
